<template>
    <section class="esesja-modal">
        <section class="esesja-modal__wraper">
            <section class="esesja-modal__wraper__header">
                <h3 class="esesja-modal__wraper__header__title">{{$t('com.file.update-file-name-modal.edit-attachement')}}</h3>
                <button class="esesja-modal__wraper__header__exit-btn"
                        @click=" (e)=>{e.preventDefault(); this.$emit('closeUpdateFileName');}">
                    <img src="../../../../../assets/icons/components/exit-btn.svg" />
                </button>
            </section>
            <perfect-scrollbar class="esesja-modal__wraper__body">
                <label class="esesja-modal__wraper__body__label">{{$t('com.file.edit-announcement.name')}}</label>
                <section class="esesja-modal__row">
                    <textarea
                           maxlength="500"
                           rows="3"
                           :placeholder="$t('com.file.add-link-modal.file-name-placeholder')"
                           class="esesja-modal__wraper__body__input"
                           v-model="name">
                    </textarea>
                    <CharactersCounter :text="name" maxLenght=500 />
                </section>

                <section>
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch" id="public-attachement" v-model="isPublic" @change="changeVisibleFlags()"  />
                        <label class="form-bootstrap-check-label" for="public-attachement">{{$t('com.file.add-link-modal.public')}}</label>
                        <section name="externalTrigger2"
                                 class="tip-btn">
                            <img src="../../../../../assets/icons/components/tooltip.svg"
                                 class="tooltip" />
                            <Hint :title="$t('com.file.add-group.public-file')"
                                  :text="$t('com.file.add-link-modal.public-file-info-hint')" />
                        </section>
                    </div>
                </section>

                <section>
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch" id="visible-for-users" v-model="isVisibleForUsers" @change="changePublicFlags()"  />
                        <label class="form-bootstrap-check-label" for="visible-for-users">{{$t('com.file.add-link-modal.show-for-users')}}</label>
                        <section name="externalTrigger2"
                                 class="tip-btn">
                            <img src="../../../../../assets/icons/components/tooltip.svg"
                                 class="tooltip" />
                            <Hint style="left: calc(100% - 310px)" :title="$t('com.file.add-link-modal.show-for-users')"
                                  :text="$t('com.file.add-link-modal.show-for-users-info-hint')" />
                        </section>
                    </div>
                </section>

                <section>
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch" id="register-attachement" v-model="isInRegister" />
                        <label class="form-bootstrap-check-label" for="register-attachement">{{$t('com.file.nav-data.register')}}</label>
                        <section name="externalTrigger2"
                                 class="tip-btn">
                            <img src="../../../../../assets/icons/components/tooltip.svg"
                                 class="tooltip" />
                            <Hint :title="$t('com.file.update-file-name-modal.visible-in-register')"
                                  :text="$t('com.file.update-file-name-modal.visible-in-register-hint')" />
                        </section>
                    </div>
                </section>

                <section v-if="att.dateTime != undefined && att.dateTime != null">
                    <p style="padding: 10px;">{{$t('com.file.session-metadata-modal.add-time')}}: {{formatDateToDisplay(att.dateTime)}}</p>
                </section>

                <section v-if="isResolution">
                    <p style="font-size: 11px;">*{{$t('com.file.update-file-name-modal.resolution-information')}}</p>
                </section>

                <section class="esesja-modal__wraper__body__bottom" style="margin-top: 20px;">
                    <button class="esesja-modal__wraper__body__bottom-button"
                            @click="this.$emit('closeUpdateFileName')">
                        {{$t('com.global.cancel')}}
                    </button>
                    <button class="
                        esesja-modal__wraper__body__bottom-button
                        esesja-modal__wraper__body__bottom-button--red
                    "
                            @click="handleSaveClick" :disabled="checkNameIsEmpty(name) == true">
                            {{$t('com.global.save')}}
                    </button>
                </section>
            </perfect-scrollbar>
        </section>
        <LoaderInside v-if="isLoading" />
    </section>
</template>

<script>
import LoaderInside from "../../../../BasicControls/LoaderInside.vue";
import Hint from "../../../../BasicControls/Hint.vue";
import AttachmentService from "../../../../../services/attachments.service";
import CharactersCounter from "../../../../../components/BasicControls/CharactersCounter.vue"

export default {
    name: "UpdateFileNameModal",
    data() {
        return {
            name: this.att.name,
            isLoading: false,
            isPublic: this.att.public == 1 ? true : false,
            isInRegister: this.att.show_in_register == 1 ? true : false,
            isVisibleForUsers: this.att.visible_for_users == 1 ? true : false
        };
    },
    props: {
        pointID: Number,
        att: Object,
        isResolution:{
            type: Boolean,
            default: false
        }
    },
    components: {
        LoaderInside,
        Hint,
        CharactersCounter
    },
    methods: {
        changeVisibleFlags() {
            if (this.isPublic) {
                this.isVisibleForUsers = true;
            }
        },
        changePublicFlags() {
            if (!this.isVisibleForUsers) {
                this.isPublic = false;
            }
        },
        checkNameIsEmpty(name) {
            if (name === null || name === undefined)
                return true;

            if (name.length === 0)
                return true;

            if (name.trim() === "")
                return true;

            if (name.length > 500)
                return true;

            return false;
        },
        handleSaveClick() {
            if (this.name.length == 0)
                return;

            this.isLoading = true;
            const data = {
                id: this.att.id,
                name: this.name,
                isPublic: this.isPublic,
                isInRegister: this.isInRegister,
                isVisibleForUsers: this.isVisibleForUsers
            };
            AttachmentService.updateFile(this.att.id, this.pointID, data)
                .then(() => {
                    this.name = "";
                    this.isPublic = false;
                    this.$emit("reload");
                    this.$emit("closeUpdateFileName");
                    this.isLoading = false;
                });
        },
        formatDateToDisplay(value) {
            var date = new Date(value)
            var d = date.toLocaleString('default', {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            });

            return d;
        },
    },
};
</script>

<style lang="scss" scoped>
    @use  '../../../../../assets/scss/esesja-modal.scss';

    .esesja-modal__wraper {
        min-width: 500px;
    }

    .switch-section {
        display: flex;
        margin-bottom: 10px;
        margin-top: 10px;
    }

    .tooltip {
        position: relative;
        left: 5px;
        top: -3px;
    }

    .tip-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0px;
        background-color: transparent;
        width: 20px;
        height: 20px;
        position: relative;
        cursor: pointer;

        &:hover .hint {
            opacity: 1;
            display: block;
        }
    }
</style>
